import React from "react";

const IpInstaller = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props?.width || 21}
    height={props?.height || 20}
    viewBox="0 0 21 20"
    fill="none"
    {...props}
  >
    {/* Monitor screen */}
    <rect
      x="1.5"
      y="2"
      width="18"
      height="12"
      rx="1.5"
      stroke="#6880CF"
      strokeWidth="1.5"
      fill="none"
    />
    {/* Monitor stand neck */}
    <line
      x1="10.5"
      y1="14"
      x2="10.5"
      y2="17"
      stroke="#6880CF"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    {/* Monitor stand base */}
    <line
      x1="7.5"
      y1="17"
      x2="13.5"
      y2="17"
      stroke="#6880CF"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    {/* Download arrow shaft */}
    <line
      x1="10.5"
      y1="5"
      x2="10.5"
      y2="11"
      stroke="#6880CF"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    {/* Download arrow head */}
    <polyline
      points="7.5,9 10.5,12 13.5,9"
      stroke="#6880CF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </svg>
);

export default IpInstaller;
